import EntityModel from '@/common/models/entity-model';

export default class InvoiceTransactionModel extends EntityModel {
    hydrate({
        invoiceId = null,
        transactionId = null,
        amount = null,
        currency = null,
    } = {}) {
        this.invoiceId = invoiceId;
        this.transactionId = transactionId;
        this.amount = amount;
        this.currency = currency;
    }
}
